<nb-card>
  <nb-card-body>
<wr-list-detail-split-view [nbSpinner]="!!(loading$|async)"
                           [data$]="collections$"
                           [searchText]="searchText$.value"
                           [loadDetailFunc]="loadDetail"
                           (searchTextChange)="searchText$.next($event)"
                           (addItemClicked)="showAddDialog()"
                           [canCreate]="canCreate">

  <div listHeader class="folder-nav">
    <div class="breadcrumb">
      <button type="button" class="crumb crumb-home" (click)="navigateToRoot()">
        <nb-icon icon="home-outline" pack="eva"></nb-icon>
        <span>Start</span>
      </button>
      <ng-container *ngFor="let segment of pathSegments; let i = index">
        <nb-icon icon="chevron-right-outline" pack="eva" class="crumb-sep"></nb-icon>
        <button type="button" class="crumb"
                [class.current]="i === pathSegments.length - 1"
                (click)="navigateToSegment(i)">{{ segment }}</button>
      </ng-container>
    </div>
    <button type="button" class="folder-browse"
            [disabled]="subfolders.length === 0"
            (click)="openFolderDialog()">
      <nb-icon icon="folder-outline" pack="eva"></nb-icon>
      <span>Ordner</span>
      <span class="folder-count" *ngIf="subfolders.length > 0">{{ subfolders.length }}</span>
    </button>
  </div>

  <ng-template #folderDialog let-ref="dialogRef">
    <nb-card class="folder-dialog">
      <nb-card-header class="folder-dialog-header">
        <span class="title">
          <nb-icon icon="folder-outline" pack="eva"></nb-icon>
          Ordner auswählen
        </span>
        <button type="button" class="folder-dialog-close" (click)="ref.close()">
          <nb-icon icon="close-outline" pack="eva"></nb-icon>
        </button>
      </nb-card-header>
      <nb-card-body class="folder-dialog-body">
        <button type="button" *ngFor="let folder of subfolders"
                class="folder-row"
                (click)="navigateToFolder(folder.name); ref.close()">
          <nb-icon icon="folder-outline" pack="eva" class="folder-row-icon"></nb-icon>
          <span class="folder-row-name">{{ folder.name }}</span>
          <span class="folder-row-count">{{ folder.count }}</span>
          <nb-icon icon="arrow-ios-forward-outline" pack="eva" class="folder-row-arrow"></nb-icon>
        </button>
      </nb-card-body>
    </nb-card>
  </ng-template>

  <ng-template wrListItem let-collection>
    <div class="custom-field-wrapper">
      <div class="collection-header">
        <span class="color-dot" [style.background]="collection.color || '#ccc'"></span>
        <span class="name">{{ collection.title }}</span>
      </div>
      <span *ngIf="collection.description" class="description">{{ collection.description }}</span>
      <span *ngIf="collection.category" class="category">{{ collection.category }}</span>
    </div>
  </ng-template>

  <ng-template wrDetailView let-detail>
    <wr-form-actions [form]="customFieldCollectionForm.form"
                     [canEdit]="customFieldCollectionForm.canEdit"
                     [deleteAction]="deleteAction"
                     [deleteDialog]="deleteDialogAction"
                     [saveAction]="saveAction">
      <wr-custom-field-collection-form #customFieldCollectionForm [customFieldCollection]="detail">
      </wr-custom-field-collection-form>
    </wr-form-actions>
  </ng-template>
</wr-list-detail-split-view>
  </nb-card-body>
</nb-card>
